import { useEffect, useState, useRef, Fragment } from 'react';

import { layout } from '../../themes/layout';

import DividerGrid from '../../components/divider_grid/divider_grid';
import { Quantity } from '../../components/divider_grid/divider_grid.type';
import PageTitle from "../../components/page's_title/page-title";
import BasicBox from '../../components/box_card/box-card';
import Table from '../../components/table/table';
import SubTitulo1 from '../../components/fonts_components/sub-headers/subtitulo1';
import LoadingIcon from '../../components/button/buttons_icons_animations/loading';

import CopyIcon from '../../assets/menu_icons/copy-icon.svg';
import DownloadArrow from '../../assets/download_arrow.svg';

import {
  UnidadeTable,
  HeaderCell,
  UnidadeRow,
  ExpandIcon,
  ExpandedCell,
  SubTable,
  SubHeaderCell,
  Cell,
  ActionButton,
} from './index.style';

import { useAuth } from '../../Contexts/AuthContext';
import { isAxiosError } from 'axios';
import axiosInstance from '../../module/axios.module';

import BuscaClienteSubunidade, {
  IBuscaUnidade,
} from '../../util/buscaClienteSubunidade';
import BuscaParcelaAtrasadaRM from './buscaParcelaAtrasadaRM';
import type { IParcelaAtrasada } from './buscaParcelaAtrasadaRM';
import SalvarPropostaAtrasada from './salvarPropostaAtrasada';
import BuscaBoletos, { IBuscaBoletos } from '../../util/buscaBoletos';
import BuscaBoletoAvulso, {
  IBuscaBoletosAvulsos,
} from '../../util/buscaBoletosAvulsos';
import BoletoPDF from '../../util/boletoPDF';
import LogBoletos from '../../util/logBoletos';
import BuscaIP from '../../util/buscaIP';
import { formatoData } from '../../util/formatoData';
import ReadableValue from '../../util/transformaEmMoeda';

export function BoletosScreen() {
  const [boletos, setBoletos] = useState<IBuscaBoletos | []>([]);
  const [boletosAvulsos, setBoletosAvulsos] = useState<
    IBuscaBoletosAvulsos | []
  >([]);
  const [unidades, setUnidades] = useState<IBuscaUnidade | []>([]);
  const [loadingUnidades, setLoadingUnidades] = useState(false);
  const [expandedNumVenda, setExpandedNumVenda] = useState<number | null>(null);
  const [parcelasPorVenda, setParcelasPorVenda] = useState<
    Record<number, IParcelaAtrasada[]>
  >({});
  const [baixandoBoletosAvulsos, setBaixandoBoletosAvulsos] = useState(false);
  const [baixandoBoletos, setBaixandoBoletos] = useState(false);
  const [invoice, setInvoice] = useState({
    title: '',
    base64pdf: '',
  });
  const [loadingReq, setLoadingReq] = useState(false);
  const [selectedFaturas, setSelectedFaturas] = useState<number[]>([]);
  const [submittingProposta, setSubmittingProposta] = useState(false);
  const [propostaMessage, setPropostaMessage] = useState<{
    type: 'success' | 'error' | 'warning';
    text: string;
  } | null>(null);

  const { access_token, user } = useAuth();

  const DonwloadButtonRef = useRef<HTMLAnchorElement>(null);
  const baseUrl = axiosInstance.getUri().replace(/\/$/, '');

  const fetchData = async () => {
    setBaixandoBoletos(() => true);
    setBaixandoBoletosAvulsos(() => true);

    BuscaBoletos(user?.codcolcfo ?? '0', user?.codcfo ?? '0', 103, access_token)
      .then((res) => {
        setBoletos(res);
        setBaixandoBoletos(() => false);
      })
      .catch(() => {
        setBoletos([]);
        setBaixandoBoletos(() => false);
      });

    BuscaBoletoAvulso(user.codcolcfo ?? '0', user.codcfo ?? '0', access_token)
      .then((res) => {
        setBoletosAvulsos(res);
        setBaixandoBoletosAvulsos(() => false);
      })
      .catch(() => {
        setBoletosAvulsos([]);
        setBaixandoBoletosAvulsos(() => false);
      });

    setLoadingUnidades(true);
    try {
      const result = await BuscaClienteSubunidade(
        user?.codcolcfo ?? '0',
        user?.codcfo ?? '0',
        103,
        access_token,
      );
      const unidadesFiltradas = result.filter((u) => u.numVenda);
      setUnidades(unidadesFiltradas);

      const parcelasPromises = unidadesFiltradas.map(async (u) => {
        try {
          const parcelas = await BuscaParcelaAtrasadaRM(
            u.numVenda,
            String(u.codcoligada),
            access_token,
          );
          return { numVenda: u.numVenda, parcelas };
        } catch {
          return { numVenda: u.numVenda, parcelas: [] as IParcelaAtrasada[] };
        }
      });

      const results = await Promise.all(parcelasPromises);
      const newParcelasPorVenda: Record<number, IParcelaAtrasada[]> = {};
      results.forEach(({ numVenda, parcelas }) => {
        newParcelasPorVenda[numVenda] = parcelas;
      });
      setParcelasPorVenda(newParcelasPorVenda);
    } catch {
      setUnidades([]);
    } finally {
      setLoadingUnidades(false);
    }
  };

  useEffect(() => {
    fetchData().catch(() => undefined);
  }, [user]);

  const handleDownload = async (
    codColigada: number,
    idlan: number,
    title: string,
  ) => {
    setLoadingReq(true);
    try {
      const ip = await BuscaIP();

      const today = new Date();
      const acao = `O usuário ${user.nome}, de id ${
        user.id
      }, sob o IP: ${ip} baixou o boleto de codColigada: ${codColigada} e idLan: ${idlan}.
      ${today.toString()}`;

      const downloadPDF = await BoletoPDF(codColigada, idlan, access_token);

      if (downloadPDF == '') throw new Error();

      await LogBoletos(user.id, ip, acao, access_token);

      setInvoice({ title: title, base64pdf: downloadPDF });

      const res = await fetch(`data:application/pdf;base64,${downloadPDF}`);
      const blob = await res.blob();
      const newUrl = window.URL.createObjectURL(blob);

      DonwloadButtonRef.current?.setAttribute(
        'href',
        // `data:application/pdf;base64,${downloadPDF}`,
        newUrl,
      );
      btoa;
      DonwloadButtonRef.current?.setAttribute('target', '_blank');
      DonwloadButtonRef.current?.setAttribute('rel', 'noopener noreferrer');
      // DonwloadButtonRef.current?.setAttribute('download', title);
      DonwloadButtonRef.current?.click();

      setLoadingReq(false);
    } catch (e) {
      setLoadingReq(false);
    }
  };

  const handleCheckboxChange = (idlan: number) => {
    if (!expandedNumVenda) return;

    const parcelas =
      parcelasPorVenda[expandedNumVenda]
        ?.slice()
        .sort(
          (a, b) =>
            new Date(a.dataVencimento).getTime() -
            new Date(b.dataVencimento).getTime(),
        ) ?? [];

    const indicesParcelas = parcelas.map((p) => p.idlan);
    const indexAtual = indicesParcelas.indexOf(idlan);

    setSelectedFaturas((prev) => {
      const isSelected = prev.includes(idlan);

      if (isSelected) {
        return prev.filter((id) => {
          const idx = indicesParcelas.indexOf(id);
          return idx < indexAtual;
        });
      }

      const todosAnterioresSelecionados = indicesParcelas
        .slice(0, indexAtual)
        .every((id) => prev.includes(id));

      if (!todosAnterioresSelecionados) return prev;

      return [...prev, idlan];
    });
  };

  const handleToggleUnidade = (numVenda: number) => {
    if (expandedNumVenda === numVenda) {
      setExpandedNumVenda(null);
      return;
    }

    setExpandedNumVenda(numVenda);
    setSelectedFaturas([]);
  };

  const vendasComParcelas = Object.entries(parcelasPorVenda)
    .filter(([, p]) => p.length > 0)
    .map(([numVenda]) => Number(numVenda));

  const handleSalvarProposta = async () => {
    if (selectedFaturas.length === 0 || !expandedNumVenda) return;

    setPropostaMessage(null);

    const parcelas = parcelasPorVenda[expandedNumVenda]?.slice() ?? [];

    const parcelasSelecionadas = parcelas
      .filter((p) => selectedFaturas.includes(p.idlan))
      .map((p) => ({ idlan: p.idlan, codcoligada: p.codcoligada }));

    setSubmittingProposta(true);
    try {
      const res = await SalvarPropostaAtrasada(
        {
          numVenda: expandedNumVenda,
          parcela: parcelasSelecionadas,
        },
        access_token,
      );

      if (res?.Success) {
        setPropostaMessage({
          type: 'success',
          text: res.Message || 'Proposta salva com sucesso.',
        });
        setSelectedFaturas([]);
        setExpandedNumVenda(null);
        setParcelasPorVenda({});
        fetchData().catch(() => undefined);
      } else {
        setPropostaMessage({
          type: 'error',
          text: res?.Message || 'Erro ao salvar proposta.',
        });
      }
    } catch (error: unknown) {
      const msg = isAxiosError(error)
        ? (error.response?.data as { Message?: string })?.Message ||
          'Erro ao salvar proposta. Tente novamente.'
        : 'Erro ao salvar proposta. Tente novamente.';
      setPropostaMessage({
        type: 'error',
        text: msg,
      });
    } finally {
      setSubmittingProposta(false);
    }
  };

  return (
    <>
      <DividerGrid quantity={Quantity.one}>
        <PageTitle>
          <span>Boletos</span>
          <img src={CopyIcon} alt="ícone de uma folha de papel" />
        </PageTitle>

        {baixandoBoletos || baixandoBoletosAvulsos ? (
          <p style={{ gridArea: '2 / 1 / 3 / 2' }}>
            Carregando
            <span style={{ marginLeft: '15px' }}>
              <LoadingIcon />
            </span>
          </p>
        ) : null}

        {loadingReq ? (
          <p style={{ gridArea: '2 / 1 / 3 / 2' }}>
            Baixando boleto
            <span style={{ marginLeft: '15px' }}>
              <LoadingIcon />
            </span>
          </p>
        ) : null}

        {!boletos.length &&
        !boletosAvulsos.length &&
        !loadingReq &&
        !baixandoBoletos &&
        !baixandoBoletosAvulsos ? (
          <div style={{ gridColumn: '1/-1' }}>
            <p>Não há itens disponíveis no momento.</p>
          </div>
        ) : null}

        <>
          {boletosAvulsos.length ? (
            <BasicBox gridArea="3 / 1 / 4 / 2" gridAreaMobile="2 / 1 / 3 / 3">
              <div style={{ marginBottom: '25px' }}>
                <SubTitulo1 color={layout.color.main_colors.main}>
                  Boletos avulsos
                </SubTitulo1>
              </div>
              <Table
                download={true}
                headers={['Download', 'Unidade', ' ', 'Nome do arquivo']}
                values={boletosAvulsos.map((bol) => {
                  return [
                    <a
                      style={{
                        display: 'block',
                        width: '100%',
                        color: '#363D40',
                        height: '100%',
                      }}
                      download={bol.nomeArquivoExibicao.replace(' ', '_')}
                      href={baseUrl + bol.nomeArquivo}
                      target="_SEJ"
                      rel="noopener noreferrer"
                    >
                      <img src={DownloadArrow} />
                    </a>,
                    <a
                      style={{
                        display: 'block',
                        width: '100%',
                        color: '#363D40',
                        height: '100%',
                      }}
                      download={bol.nomeArquivoExibicao.replace(' ', '_')}
                      href={baseUrl + bol.nomeArquivo}
                      target="_SEJ"
                      rel="noopener noreferrer"
                    >
                      {bol.empreendimento +
                        '-' +
                        bol.unidade +
                        '-' +
                        bol.subunidade}
                    </a>,
                    <span>&nbsp;</span>,
                    <a
                      style={{
                        display: 'block',
                        width: '100%',
                        color: '#363D40',
                        height: '100%',
                      }}
                      download={bol.nomeArquivoExibicao.replace(' ', '_')}
                      href={baseUrl + bol.nomeArquivo}
                      target="_SEJ"
                      rel="noopener noreferrer"
                    >
                      {bol.nomeArquivoExibicao}
                    </a>,
                  ];
                })}
              />
            </BasicBox>
          ) : null}

          {boletos.length ? (
            <BasicBox gridArea="4 / 1 / 5 / 2" gridAreaMobile="3/1/4/3">
              <div style={{ marginBottom: '25px' }}>
                <SubTitulo1 color={layout.color.main_colors.main}>
                  Boletos
                </SubTitulo1>
              </div>
              <Table
                headers={['Download', 'Unidade', 'Vencimento', 'Valor(R$)']}
                download={true}
                values={
                  boletos
                    ? boletos.map((e) => {
                        const arr = [
                          <a
                            style={{
                              cursor: 'pointer',
                              display: 'block',
                              width: '100%',
                              color: '#363D40',
                              height: '100%',
                            }}
                            onClick={() =>
                              handleDownload(
                                e.codcoligada,
                                e.idlan,
                                e.empreendimento +
                                  '-' +
                                  formatoData(e.dataVencimento),
                              )
                            }
                          >
                            <img src={DownloadArrow} />
                          </a>,
                          <a
                            style={{
                              cursor: 'pointer',
                              display: 'block',
                              width: '100%',
                              color: '#363D40',
                              height: '100%',
                            }}
                            onClick={() =>
                              handleDownload(
                                e.codcoligada,
                                e.idlan,
                                e.empreendimento +
                                  '-' +
                                  formatoData(e.dataVencimento),
                              )
                            }
                          >
                            {e.empreendimento}
                          </a>,
                          <a
                            style={{
                              cursor: 'pointer',
                              display: 'block',
                              width: '100%',
                              color: '#363D40',
                              height: '100%',
                            }}
                            onClick={() =>
                              handleDownload(
                                e.codcoligada,
                                e.idlan,
                                e.empreendimento +
                                  '-' +
                                  formatoData(e.dataVencimento),
                              )
                            }
                          >
                            {formatoData(e.dataVencimento)}
                          </a>,
                          <a
                            style={{
                              cursor: 'pointer',
                              display: 'block',
                              width: '100%',
                              color: '#363D40',
                              height: '100%',
                            }}
                            onClick={() =>
                              handleDownload(
                                e.codcoligada,
                                e.idlan,
                                e.empreendimento +
                                  '-' +
                                  formatoData(e.dataVencimento),
                              )
                            }
                          >
                            {ReadableValue(e.valorBoleto ?? e.valorAtual)}
                          </a>,
                        ];

                        return arr;
                      })
                    : [['']]
                }
              />
            </BasicBox>
          ) : null}

          {unidades.length && vendasComParcelas.length > 0 ? (
            <BasicBox gridArea="5 / 1 / 6 / 2" gridAreaMobile="4/1/5/3">
              <div style={{ marginBottom: '25px' }}>
                <SubTitulo1 color={layout.color.main_colors.main}>
                  Parcelas vencidas
                </SubTitulo1>
              </div>

              {loadingUnidades ? (
                <p style={{ textAlign: 'center' }}>
                  Carregando
                  <span style={{ marginLeft: '15px' }}>
                    <LoadingIcon />
                  </span>
                </p>
              ) : (
                <UnidadeTable>
                  <thead>
                    <tr>
                      <HeaderCell />
                      <HeaderCell>Empreendimento</HeaderCell>
                      <HeaderCell>Bloco</HeaderCell>
                      <HeaderCell>Unidade</HeaderCell>
                    </tr>
                  </thead>
                  <tbody>
                    {unidades
                      .filter((u) => vendasComParcelas.includes(u.numVenda))
                      .map((u) => (
                        <Fragment key={u.numVenda}>
                          <UnidadeRow
                            $isExpanded={expandedNumVenda === u.numVenda}
                            onClick={() => handleToggleUnidade(u.numVenda)}
                          >
                            <td>
                              <ExpandIcon
                                $isExpanded={expandedNumVenda === u.numVenda}
                              >
                                &#9654;
                              </ExpandIcon>
                            </td>
                            <td>{u.nomeEmpreendimento}</td>
                            <td>{u.unidade}</td>
                            <td>{u.subUnidade}</td>
                          </UnidadeRow>
                          {expandedNumVenda === u.numVenda && (
                            <tr>
                              <ExpandedCell colSpan={4}>
                                <SubTable>
                                  <thead>
                                    <tr>
                                      <SubHeaderCell />
                                      <SubHeaderCell>Vencimento</SubHeaderCell>
                                      <SubHeaderCell>
                                        Valor Atualizado(R$)
                                      </SubHeaderCell>
                                      <SubHeaderCell>
                                        Encargos(R$)
                                      </SubHeaderCell>
                                      <SubHeaderCell>
                                        Valor Total da Parcela(R$)
                                      </SubHeaderCell>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {[...parcelasPorVenda[u.numVenda]]
                                      .sort(
                                        (a, b) =>
                                          new Date(a.dataVencimento).getTime() -
                                          new Date(b.dataVencimento).getTime(),
                                      )
                                      .map((p) => (
                                        <tr key={p.idlan}>
                                          <Cell>
                                            {(() => {
                                              const sorted = [
                                                ...parcelasPorVenda[u.numVenda],
                                              ].sort(
                                                (a, b) =>
                                                  new Date(
                                                    a.dataVencimento,
                                                  ).getTime() -
                                                  new Date(
                                                    b.dataVencimento,
                                                  ).getTime(),
                                              );
                                              const idx = sorted.findIndex(
                                                (x) => x.idlan === p.idlan,
                                              );
                                              const olderUnselected = sorted
                                                .slice(0, idx)
                                                .some(
                                                  (x) =>
                                                    !selectedFaturas.includes(
                                                      x.idlan,
                                                    ),
                                                );
                                              const canSelect =
                                                !selectedFaturas.includes(
                                                  p.idlan,
                                                )
                                                  ? !olderUnselected
                                                  : true;
                                              return (
                                                <input
                                                  type="checkbox"
                                                  checked={selectedFaturas.includes(
                                                    p.idlan,
                                                  )}
                                                  disabled={
                                                    !canSelect ||
                                                    submittingProposta
                                                  }
                                                  onChange={() =>
                                                    handleCheckboxChange(
                                                      p.idlan,
                                                    )
                                                  }
                                                  style={{
                                                    margin: '0',
                                                    cursor:
                                                      !canSelect ||
                                                      submittingProposta
                                                        ? 'not-allowed'
                                                        : 'pointer',
                                                  }}
                                                />
                                              );
                                            })()}
                                          </Cell>
                                          <Cell>
                                            {formatoData(p.dataVencimento)}
                                          </Cell>
                                          <Cell>
                                            {ReadableValue(p.valorAtual)}
                                          </Cell>
                                          <Cell>
                                            {ReadableValue(p.valorJuros)}
                                          </Cell>
                                          <Cell>
                                            {ReadableValue(p.valorDevido)}
                                          </Cell>
                                        </tr>
                                      ))}
                                  </tbody>
                                </SubTable>
                              </ExpandedCell>
                            </tr>
                          )}
                        </Fragment>
                      ))}
                  </tbody>
                </UnidadeTable>
              )}

              {propostaMessage && (
                <div
                  style={{
                    padding: '10px 16px',
                    marginTop: '16px',
                    borderRadius: '8px',
                    fontSize: '0.875rem',
                    fontWeight: 500,
                    backgroundColor:
                      propostaMessage.type === 'success'
                        ? '#d4edda'
                        : propostaMessage.type === 'warning'
                        ? '#fff3cd'
                        : '#f8d7da',
                    color:
                      propostaMessage.type === 'success'
                        ? '#155724'
                        : propostaMessage.type === 'warning'
                        ? '#856404'
                        : '#721c24',
                    border: `1px solid ${
                      propostaMessage.type === 'success'
                        ? '#c3e6cb'
                        : propostaMessage.type === 'warning'
                        ? '#ffeeba'
                        : '#f5c6cb'
                    }`,
                  }}
                >
                  {propostaMessage.text}
                </div>
              )}

              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  marginTop: '20px',
                }}
              >
                <ActionButton
                  onClick={handleSalvarProposta}
                  disabled={selectedFaturas.length === 0 || submittingProposta}
                  $disabled={selectedFaturas.length === 0 || submittingProposta}
                >
                  {submittingProposta ? 'Salvando...' : 'Gerar Boleto'}
                </ActionButton>
              </div>
            </BasicBox>
          ) : null}
        </>

        <a
          ref={DonwloadButtonRef}
          download={invoice.title}
          href={`data:application/pdf;base64,${invoice.base64pdf}`}
          title="Download pdf document"
        />
      </DividerGrid>
    </>
  );
}
